import { useState, useEffect } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: "#services", label: "Services" },
    { href: "#translate-cloud", label: "Translate Cloud API" },
    { href: "#pricing", label: "Pricing" },
    { href: "#testimonials", label: "Testimonials" },
    { href: "#cta", label: "Contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav" : "bg-white/70"
      }`}
    >
      <div className="container-wide section-padding">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center gap-2.5" aria-label="SaaS ForceKeys Services Home">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/3ef87599-1241-4809-b65e-3d0fc5310a8f.png"
                alt="SaaS ForceKeys Services logo"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-outfit font-bold text-lg md:text-xl tracking-tight text-gray-900">
              SaaS ForceKeys Services
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap text-gray-500 hover:text-gray-900 hover:bg-gray-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://support.saas.forcekeys.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap text-gray-500 hover:text-gray-900 hover:bg-gray-100"
            >
              Support
            </a>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://forcekeys.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="px-5 py-2.5 bg-emerald-600 text-white rounded-full text-sm font-semibold hover:bg-emerald-700 transition-all duration-300 whitespace-nowrap"
            >
              Get Started
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-gray-600 hover:text-gray-900 transition-colors"
            aria-label="Menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden glass-nav border-t border-gray-100">
          <nav className="section-padding py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://support.saas.forcekeys.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
            >
              Support
            </a>
            <a
              href="https://forcekeys.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              onClick={() => setMobileOpen(false)}
              className="mt-2 px-5 py-3 bg-emerald-600 text-white rounded-full text-sm font-semibold text-center hover:bg-emerald-700 transition-colors"
            >
              Get Started
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
